import type { TFunction } from 'i18next';

import yup from '../../../shared/validation';

export function getTrainingFormValidation(t: TFunction) {
  return yup.object({
    createForOthers: yup.boolean(),
    trainingOwner: yup
      .object()
      .nullable()
      .test(
        'training-owner-when-for-others',
        t('trainings.trainingOwnerRequired'),
        function trainingOwnerRequired(value) {
          const { createForOthers } = this.parent as {
            createForOthers?: boolean;
          };
          if (createForOthers) {
            return (
              value != null && typeof (value as { id?: string }).id === 'string'
            );
          }
          return true;
        },
      ),
    title: yup
      .string()
      .max(256, t('formikValidation.maxLength').replace('{0}', '256'))
      .required(t('formikValidation.nameRequired')),
    trainingSets: yup.array().of(
      yup.object().shape({
        exercise: yup.object().required(t('formikValidation.exerciseRequired')),
        trainingSetItems: yup.array().of(
          yup.object().shape({
            trainingSetItemOptions: yup.array().of(
              yup.object().shape({
                programValue: yup
                  .number()
                  .nullable()
                  // .required(t('formikValidation.valueRequired'))
                  .min(0, t('formikValidation.minValue').replace('{0}', '0')),
              }),
            ),
          }),
        ),
      }),
    ),
  });
}
